'use strict';

const i18n = require('i18next');
const _ = require('underscore');
const Mn = require('backbone.marionette');
const ElementMention = require('system/util/element-mention');
const Route = require('common/route');
const Dialog = require('common/util/dialog');
const Logger = require('common/util/logger');
const Snackbar = require('common/util/snackbar');
const DiagramAction = require('system/domain/action/diagram');
const DiagramRepository = require('system/domain/repository/diagram');
const ElementRepository = require('system/domain/repository/element');
const ShortcutModalView = require('system/ui/view/modal/shortcut');
const ModalView = require('common/ui/view/modal/index');
const CommitCommentModalView = require('system/ui/view/modal/commit-comment');
const MenuTemplate = require('system/ui/template/toolbar-menu.hbs');
const ConflictPopoverTemplate = require('system/ui/template/conflict-popover.hbs');
const Router = require('balus/app/router/index');

const MenuView = Mn.View.extend({
    template: MenuTemplate,
    events: {
        'click .menu-delete-diagram': 'deleteConfirm',
        'click .menu-add-symbolic-node': 'addSymbolicNode',
        'click .menu-shortcut': 'showShortcut',
        'click .menu-fit-diagram': 'fitDiagram',
        'click .menu-print-diagram': 'printDiagram',
        'click .menu-edit-mode': 'editMode',
        'click .menu-multi-mode': 'multiMode',
        'click .save-all-elements': 'save'
    },
    /**
     * Menu 表示用の View。
     *
     * @constructs
     */
    initialize: function(params) {
        _.bindAll(this, 'checkState');

        this._diagram = params.model;
        this._context = params.context; // このViewを呼び出しているtoolbar/index.jsを呼び出しているbody/diagram/index.jsを見ると、このcontextはOldContextらしい
        this._channel = params.channel;
        this._project = params.project;
        this._mode = 'edit';
        this._previousMode = null;

        ElementRepository.getNodes({
            context: this._context
        }).on('change:state', this.checkState);
        ElementRepository.getLinks({
            context: this._context
        }).on('change:state', this.checkState);
        DiagramRepository.getNodeMetas({
            context: this._context
        }).on('change:state', this.checkState);
        DiagramRepository.getLinkMetas({
            context: this._context
        }).on('change:state', this.checkState);

        this.listenTo(this.getOption('auth'), 'change:mode', this.setModeView);
        _.bindAll(this, 'deleteConfirm', 'deleting');
    },

    onRender: function() {
        this.$view = this.$('.menu-edit-mode');
        this.$save = this.$('.save-all-elements');
        this.$conflict = this.$('.conflict-elements');
        this.$miscMenu = this.$('.misc-menu');

        this.$view.hide();
        this.$save.hide();
        this.$conflict.hide();

        this.$conflict.on('shown.bs.popover', function() {
            (new ElementMention(this._context, this._channel)).addClickHandler($(this));
        });
        this.$('[data-toggle="tooltip"]').tooltip();

        this.setModeView();
        this.checkState();
        return this;
    },

    mode: function() {
        return this._mode;
    },

    changeMode: function(mode) {
        this._channel.request('change:mode', mode);
    },

    setModeView: function() {
        const mode = this.getOption('auth').get('mode');

        if(mode === 'edit') {
            this.onEditMode();
        } else if(mode === 'view') {
            this.onViewMode();
        } else if(mode === 'snapshot') {
            this.onSnapshotMode();
        } else {
            this.onMultiMode();
        }
    },

    showDefaultMenus: function() {
        this.$miscMenu.show();
    },

    hideDefaultMenus: function() {
        this.$miscMenu.hide();
    },

    editMode: function() {
        this.changeMode('edit');
    },

    onEditMode: function() {
        this.showDefaultMenus();
        this.$view.hide();
    },

    onSnapshotMode: function() {
        this.hideDefaultMenus();
        this.$view.hide();
    },

    multiMode: function() {
        this.changeMode('multi');
    },

    onMultiMode: function() {
        this.hideDefaultMenus();
        this.$view.show();
    },

    addSymbolicNode: function() {
        this._channel.request('cmd:menu:symbolic:render')
    },

    showShortcut: function() {
        const view = new ShortcutModalView();
        $('#modal-container').append(view.render().el);

        view.show();
    },

    fitDiagram: function() {
        this._channel.request('canvas:showFull');
    },

    printDiagram: function() {
        this._channel.request('print:canvas');
    },

    _getElementsStateOf: function(state) {
        const diagram = DiagramRepository.getDiagrams({
            context: this._context
        }).get(this._diagram.id);
        const _need_save = (model) => {
            if(!diagram.hasElement(model)) {
                return false;
            }
            if(state === 'Unsync') {
                return model.syncState.isUnsync();
            } else if(state === 'Conflict') {
                return model.syncState.isConflict();
            }
        };
        const _need_save_meta = (model) => {
            if(state === 'Unsync') {
                return model.syncState.isUnsync();
            } else if(state === 'Conflict') {
                return model.syncState.isConflict();
            }
        };
        return {
            models: {
                nodes: ElementRepository.getNodes({
                    context: this._context
                }).filter(_need_save),
                links: ElementRepository.getLinks({
                    context: this._context
                }).filter(_need_save)
            },
            metas: {
                nodes: DiagramRepository.getNodeMetas({
                    context: this._context
                }).filter(_need_save_meta),
                links: DiagramRepository.getLinkMetas({
                    context: this._context
                }).filter(_need_save_meta)
            }
        }
    },

    checkState: function() {
        const unsync = this._getElementsStateOf('Unsync');
        const conflict = this._getElementsStateOf('Conflict');

        if(_.flatten([
            conflict.models.nodes,
            conflict.models.links]).length > 0) {
            this.$save.hide();
            this.$conflict.show();
            const j = {
                nodes: _.map(conflict.models.nodes, function(m){
                    const j = m.toJSON();
                    j.path = Route.urlFor('diagram:element', {id: m.id});
                    return j;
                }),
                links: _.map(conflict.models.links, function(m){
                    const j = m.toJSON();
                    j.path = Route.urlFor('diagram:element', {id: m.id});
                    return j;
                })
            };
            this.$conflict.popover('destroy');
            this.$conflict.popover({
                title: i18n.t('diagram:popover.conflict'),
                html: true,
                content: ConflictPopoverTemplate(j),
                placement: 'bottom',
                container: $('.conflict-elements')
            });
        } else if(_.flatten([
            unsync.models.nodes,
            unsync.models.links,
            unsync.metas.nodes,
            unsync.metas.links
        ]).length === 0) {
            this.$save.hide();
            this.$conflict.hide();
        } else {
            this.$save.show();
            this.$conflict.hide();
        }
    },

    save: function() {
        const unsync = this._getElementsStateOf('Unsync');

        if(_.flatten([
            unsync.models.nodes,
            unsync.models.links,
            unsync.metas.nodes,
            unsync.metas.links
        ]).length === 0) {
            return;
        }

        const modal = new ModalView({
            title: i18n.t('diagram:commitComment.title'),
            childViewTriggers: {
                'commit': 'commit'
            },
            bodyView: new CommitCommentModalView({
                context: this.getOption('context'),
                project: this._project,
                diagram: this._diagram, // コミットコメントで関連付けるべきダイアグラムの情報を渡して、 Comment#relatedKeys に設定したい
            }),
            saveButtonEnable: true,
            onChildviewSave: function() {
                this.disableButtons();
                this.getOption('bodyView').commit();
                this.hide();
            }
        });

        modal.on('commit', commitComment => {
            this._channel.request('cmd:save', {
                nodes: unsync.models.nodes,
                links: unsync.models.links,
                nodeMetas: unsync.metas.nodes,
                linkMetas: unsync.metas.links,
                commitComment: commitComment,
            });
        });

        modal.show();
    },

    deleteConfirm: function(event) {
        Dialog.confirm({
            text: i18n.t('notify.delete-confirm', {name: this.model.get('name')}),
            okCallback: () => {
                this.deleting();
            }
        });
        event.stopPropagation();
    },

    deleting: function() {
        Logger.info('Diagram deleting ...', this.model);
        DiagramAction.deleteDiagram(this.model.getProjectId(), this.model.id)
            .then(() => {
                Snackbar.success(
                    i18n.t('balus_template_body_diagram:toolbar.feedback.delete', {name: this.model.get('name')})
                );
                Router.navigateDiagramDashboard(this.model.getProjectId());
            }, this.error);
    }
});

module.exports = MenuView;



// WEBPACK FOOTER //
// ./system/ui/view/toolbar-menu.js